__turbopack_context__.v({
  "container": "ConfigureUpsellGroupForm-module-scss-module__f1FM9G__container",
  "floatingHeader": "ConfigureUpsellGroupForm-module-scss-module__f1FM9G__floatingHeader",
  "footerContainer": "ConfigureUpsellGroupForm-module-scss-module__f1FM9G__footerContainer",
  "show": "ConfigureUpsellGroupForm-module-scss-module__f1FM9G__show",
  "topContainer": "ConfigureUpsellGroupForm-module-scss-module__f1FM9G__topContainer",
  "upsellListing": "ConfigureUpsellGroupForm-module-scss-module__f1FM9G__upsellListing",
});
